import { getEnvVariables } from "~/utils/dotenv";

export function getEnv (): Record<string, string> {
	// @ts-ignore
	return typeof useRuntimeConfig === "function"
		// @ts-ignore
		? useRuntimeConfig().public
		: getEnvVariables(".env.preprod");
}
